/**
 * @describe  存放各种API请求
 */

import * as order from './apiList/order'

export default {
  ...order
}
